export const apiEndpoint = { 
    pdfBaseUri: "https://pdf.meon.co.in",
    esignBaseUri: window.location.host.includes("localhost") ?  "http://127.0.0.1:8000" : "https://esign.meon.co.in"
}